<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-md-8 no-padding">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Notification list</span>
            </h6>
        </div>
        <div class="col-xl-12 block-style" style="margin-bottom:15px !important;padding: 20px !important; border-top-right-radius: 0px; border-top-left-radius: 0px">
            <div *ngIf="!isLoading && notifications.length == 0" class="col-xs-12">
                <a class="small-section-action">NO NOTIFICATION FOUND</a>
            </div>
            <div *ngFor="let item of notifications; let i = index" style=" cursor:pointer;padding: 0px !important;margin-bottom:10px">
                <div (click)="openNotification(item, i)" class="row notification-item" [ngStyle]="{'background-color': !item.isRead ? 'aliceblue' : 'transparent' }" style="border-radius: 5px;padding: 0.75rem 0.75rem !important;">
                    <div *ngIf="item.relatedTo.toLowerCase() == 'Post'.toLowerCase()" class="col-xl-2" style="color: #00A6B6;padding: 0px;font-size: 25px;">
                        <span class="fa fa-comment"></span>
                    </div>
                    <div *ngIf="item.relatedTo.toLowerCase() == 'SUPPORT'.toLowerCase()" class="col-xl-2" style="color: #00A6B6;padding: 0px;font-size: 25px;">
                        <span class="fa fa-headset"></span>
                    </div>
                    <div *ngIf="item.relatedTo.toLowerCase() == 'Message'.toLowerCase()" class="col-xl-2" style="color: #00A6B6;padding: 0px;font-size: 25px;">
                        <span class="fa fa-envelope"></span>
                    </div>
                    <div *ngIf="item.relatedTo.toLowerCase() == 'Instant Support'.toLowerCase()" class="col-xl-2" style="color: #00A6B6;padding: 0px;font-size: 25px;">
                        <span class="fa fa-headset"></span>
                    </div>
                    <div *ngIf="item.relatedTo.toLowerCase() == 'Connection'.toLowerCase()" class="col-xl-2" style="color: #00A6B6;padding: 0px;font-size: 25px;">
                        <span class="fa fa-user"></span>
                    </div>
                    <div *ngIf="item.relatedTo.toLowerCase() == 'Discussion'.toLowerCase()" class="col-xl-2" style="color: #00A6B6;padding: 0px;font-size: 25px;">
                        <span class="fa fa-bullhorn"></span>
                    </div>
                    <div *ngIf="item.relatedTo.toLowerCase() == 'SDR'.toLowerCase()" class="col-xl-2" style="color: #00A6B6;padding: 0px;font-size: 25px;">
                        <span class="fa fa-briefcase"></span>
                    </div>
                    <div *ngIf="item.relatedTo.toLowerCase() == 'Post_Groups'.toLowerCase()" class="col-xl-2" style="color: #00A6B6;padding: 0px;font-size: 25px;">
                        <span class="fa fa-comment"></span>
                    </div>
                    <div class="col-xl-10" style="padding: 0px;white-space: pre-wrap;">
                        <b>{{item.from}}</b> <div [innerHTML]="item.message"></div><small style="opacity:.5" class="feed-time-date">{{item.createdDate | timeAgo}}</small>
                    </div>
                </div>
            </div>
            <div *ngIf="isLoading" class="col-xs-12">
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4">
        <app-connection-list [showLoading]="myRequestedConnectionShowLoading" [title]="'Connection requests'" [connectionList]="requestedConnection"></app-connection-list>
    </div>
</div>


